export function getOnlyNumber() {
    const replacedText = String(this)?.replace(/\D/g, '');
    if (!replacedText || Number(replacedText) < 0)
        return undefined;
    return Number(replacedText);
}
;
//# sourceMappingURL=getOnlyNumbers.js.map